/**!
 * Created by Leonardo Cheslacki on 13/05/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import StudentController from './StudentController';

import WithType from './../helpers/WithType';

import config from './../../../../config';

const {default: {routes: {api, web}}} = config;

let _this = {};

/**
 *
 */
class StudentProfile extends StudentController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            data: {},
            element: null
        };

        this.$pages = 5;
        this.$paginate = 0;

        _this = this;
    };

    $functions = {
        /**
         *
         * @param event
         */
        handleClose: function (event) {
            const _this_frame = _this.getFrame();

            _this.effectFadeOut(_this_frame, 'occ_carousel');
        },

        /**
         *
         * @param event
         */
        handleOpen: function (event) {
            const _this_frame = _this.getFrame();

            _this.effectFadeIn(_this_frame, 'occ_carousel');
        },

        /**
         *
         * @param event
         */
        handlePrev: function (event) {
            _this.paginate(-1);
        },

        /**
         *
         * @param event
         */
        handleNext: function (event) {
            _this.paginate(1);
        }
    };

    addStatus = () => {
        const
            {data} = this.state,
            {occ_status, occ_status: {occ_name, occ_experience}} = this.getFrame(),
            formatted_name = _this.verifyField(data, 'profile.formatted_name'),
            year = _this.verifyField(data, 'classroom_student.year.year');

        this.addAvatar(occ_status);

        occ_name.text = formatted_name;
        occ_experience.text = year;
    };

    /**
     *
     * @param occ
     * @param uri
     */
    setAvatarCarousel = (occ, uri) => {
        if (uri) {
            let bitmap = (new createjs.Bitmap(uri));
            bitmap.image.onload = () => {
                let height = occ.nominalBounds.height;
                bitmap.scaleX = this.calcSize(bitmap.image.width, height, bitmap.scaleX);
                bitmap.scaleY = this.calcSize(bitmap.image.height, height, bitmap.scaleY);
                bitmap.x = -((height - occ.nominalBounds.width) / 2);
                occ.children = [];
                occ.addChild(bitmap);
            };
        } else {
            occ.children = [];
        }
    };

    /**
     *
     * @param increment
     */
    paginate = (increment) => {
        const
            {data} = this.state,
            images = this.verifyField(data, 'classroom_student.year.avatars'),
            {
                occ_carousel: {
                    occ_left,
                    occ_center_left,
                    occ_center,
                    occ_center_right,
                    occ_right
                }
            } = this.getFrame(),
            paginate = [
                occ_left,
                occ_center_left,
                occ_center,
                occ_center_right,
                occ_right
            ];

        if (this.isArrayIf(images)) {
            const
                paginates = [null, null, ...images, null, null],
                current = (this.$paginate + this.$pages);

            if (increment > 0) {
                (current < paginates.length) && this.$paginate++;
            } else if (increment < 0) {
                (current > this.$pages) && this.$paginate--;
            }

            for (let i = 0; i < this.$pages; i++) {
                this.setAvatarCarousel(paginate[i], this.verifyField(paginates[i + this.$paginate], 'formatted_uri'));
            }
        }
    };

    setMenuCarousel = () => {
        const {
            btn_avatar,
            occ_carousel: {
                btn_close,
                btn_prev,
                btn_next
            }
        } = this.getFrame();

        this.paginate(0);

        this._handleOpen && btn_avatar.off('mousedown', this._handleOpen);
        this._handleOpen = btn_avatar.on('mousedown', this.$functions.handleOpen);

        this._handleClose && btn_close.off('mousedown', this._handleClose);
        this._handleClose = btn_close.on('mousedown', this.$functions.handleClose);

        this._handlePrev && btn_prev.off('mousedown', this._handlePrev);
        this._handlePrev = btn_prev.on('mousedown', this.$functions.handlePrev);

        this._handleNext && btn_next.off('mousedown', this._handleNext);
        this._handleNext = btn_next.on('mousedown', this.$functions.handleNext);
    };

    startProfile = () => {
        const {button_menu_profile} = this.props;

        this.setNavbar();

        this.addStatus();

        this.setMenuCarousel();

        this.setActions(button_menu_profile);
    };

    initProfile = () => {
        this.gotoAndStopFrame(this.get(), 1);

        this.main.getForm(`${this.$root_uri}/${api.api_profile}`, {}, {
            done: ({status, errors, data}) => {
                if (Boolean(status)) {
                    this.setState({...this.state, data: data}, this.startProfile);
                } else {
                    console.log(errors);
                }
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                this.emit('process_end', {});
            }
        });
    };
}

/**
 *
 * @type {{}}
 */
StudentProfile.propTypes = {
    current_name: PropTypes.string,
    button_navbar: PropTypes.array,
    button_menu_profile: PropTypes.array
};

/**
 *
 * @type {{}}
 */
StudentProfile.defaultProps = {
    current_name: null,
    button_navbar: [
        {
            occ: 'profile',
            uri: web.uri_profile
        },
        {
            occ: 'dashboard',
            uri: web.uri_dashboard
        },
        {
            occ: 'logout',
            uri: web.uri_logout
        }
    ],
    button_menu_profile: [
        {
            occ: 'back',
            uri: web.uri_dashboard
        }
    ]
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(StudentProfile, {className: 'StudentProfile'});
